export default __webpack_public_path__ + "c8d439dba4fd957e27491be3a8c71645.svg";